
import React from 'react'
import '../scss/Notificaciones.css'

class Notificaciones extends React.Component {
  // ...
  constructor (props) {
    super(props)
    this.state = {
      notificaciones: []
    }
  }

  componentDidMount () {
    // Event listeners are only safe to add after mount,
    // So they won't leak if mount is interrupted or errors.
    if (this.props.fcm.subscribe) {
      this.props.fcm.subscribe(
        this.handleSubscriptionChange.bind(this)
      )
    }
  /*
    // External values could change between render and mount,
    // In some cases it may be important to handle this case.
    if (this.state.notificaciones !== this.props.fcm.value) {
      this.setState({
        notificaciones: this.props.fcm.value
      })
    }
    */
  }

  componentWillUnmount () {
    if (this.props.fcm.unsubscribe) {
      this.props.fcm.unsubscribe(
        this.handleSubscriptionChange
      )
    }
  }

  handleSubscriptionChange (newData) {
    // console.info('AAA', newData)
    let n = this.state.notificaciones
    n.push(newData.data)
    this.setState({
      notificaciones: n
    })
  };

  closeAndRemove () {
    this.setState({notificaciones: []})
  }

  render () {
    // console.info(this.state)
    const notificaciones = this.state.notificaciones
    if (notificaciones.length) {
      return <div className={'notificaciones__wrapper'}>
        <button className={'notificaciones__close'} onClick={this.closeAndRemove.bind(this)}>
          &times;
        </button>
        <ul className={'notificaciones__list'}>
          {notificaciones.map((row) => {
            return <li className={'notificaciones__item'} key={`${row.competicion}-${row.dorsal}`}>
              <a href={`/competicion/${row.competicion}/favoritos`}>
                {row.texto}
              </a>
            </li>
          })}
        </ul>
      </div>
    } else {
      return null
    }
  }
}

export default Notificaciones



// WEBPACK FOOTER //
// ./src/components/Notificaciones.js